import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import { translate } from 'react-i18next';
import { onboardingSteps, settingKeys } from '../../../common/enums';
import { signUpRequest, selectLoanCreationAttempt, fetchLoanCreationAttemptActions, updateLoanCreationAttemptAction } from '../../../features/auth/ducks';
import { fetchSettingsActions, selecctSettingsObject } from '../../../features/setting-management/ducks'
import { selectSetting } from '../../settings/ducks';
import { apiCallIds } from '../../../features/auth/api';
import { selectIsInProgress } from '../../../features/spinner/ducks';
import {
  StepForm1,
  StepForm2,
  StepForm3,
  StepInsurance,
  StepLayout,
  StepProgress,
  StepSideBar,
} from '../components/debtor';
import { v4 as uuidv4 } from 'uuid';
import Cookies from 'js-cookie';
import { getInsurancePrice, getLoanCreationAttemptParams, getInterestDiscount, getInterestValue } from './helpers';
import { getMonthlyPayment } from '../../../common/utils/mathHelpers';
import Spin from 'antd/lib/spin';

// Backend validates cookieId as a GUID; regenerate anything else so legacy
// cookies or crafted ?cookieId= links don't fail registration with 422.
const isGuid = value =>
  typeof value === 'string' &&
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value);

const mapStateToProps = (state, ownProps) => ({
  step: ownProps.params && ownProps.params.step,
  currentLocationState: ownProps.location.state,
  isLoading: selectIsInProgress(state, apiCallIds.SIGN_UP),
  loanCreationAttempt: selectLoanCreationAttempt(state),
  settings: selecctSettingsObject(state),
  interestRange: selectSetting(state, settingKeys.INTEREST_RANGE),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      signUp: signUpRequest,
      fetchLoanCreationAttemptActions: fetchLoanCreationAttemptActions.request,
      updateLoanCreationAttemptAction: updateLoanCreationAttemptAction.request,
      fetchSettingsActions: fetchSettingsActions.request
    },
    dispatch
  ),
  goToStep: (step, calculator) =>
    dispatch(push({ pathname: `onboarding/debtor/${step}`, state: { calculator } })),
});

@translate()
@connect(mapStateToProps, mapDispatchToProps)
export default class OnboardingDebtorContainer extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    actions: PropTypes.object.isRequired,
    goToStep: PropTypes.func.isRequired,
    step: PropTypes.string.isRequired,
    currentLocationState: PropTypes.object,
    isLoading: PropTypes.bool.isRequired,
    loanCreationAttempt: PropTypes.object,
    settings: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props)

    const cookieId = this.props.location.query.cookieId

    if (!isGuid(Cookies.get('id'))) {
      let cidFromUrl = null;
      try {
        const fParam = new URLSearchParams(window.location.search).get('f');
        if (fParam) {
          cidFromUrl = JSON.parse(atob(fParam)).cid || null;
        }
      } catch (e) { /* ignore parse errors */ }

      Cookies.set('id', [cookieId, cidFromUrl].find(isGuid) || uuidv4());
    }

    this.state = {
      // accountData: null,
      accountData: {
        address: {},
        income: {},
        costs: {},
        loan: {},
        terms: true,
        declarationOfCorrectInformation: true,
      },
      calculator: null,
      loanCreationAttempt: null,
    };
  }

  componentWillMount() {
    const { actions } = this.props;

    let cookieId = Cookies.get('id')

    actions.fetchSettingsActions()

    if (cookieId) {
      try {
        actions.fetchLoanCreationAttemptActions({ cookieId })
        const url = new URL(window.location)
        window.history.replaceState(null, null, url.hash.split("?", 1)[0])
      } catch (e) {
        console.log(e)
      }
    } else {

      let urlLocationHash = new URLSearchParams(window.location.search)

      let param = urlLocationHash.get('f')

      if (param === null) {
        if (this.props.currentLocationState.calculator) {
          const calculator = this.props.currentLocationState.calculator

          this.setState({
            ...this.state,
            calculator: calculator
          })
        }
      } else {
        try {
          let urlObject = JSON.parse(atob(param))
          let newState = {
            amount: urlObject.a,
            months: urlObject.m,
            goal: 'WHATEVER',
            interest: urlObject.i,
            payment: urlObject.p,
            paymentTotal: urlObject.pt,
            provisionFee: urlObject.pf,
            rpmn: urlObject.r,
            insurance: null,
            insuranceAmount: 0
          }

          const url = new URL(window.location)
          url.searchParams.delete('f')
          window.history.replaceState(null, null, url)

          this.setState({
            ...this.state,
            calculator: newState
          })

          this.props.actions.updateLoanCreationAttemptAction({ cookieId: Cookies.get('id'), form: newState, step: 0 })
          this.props.goToStep(onboardingSteps[0], newState)
        } catch (e) {
          console.log(e)
        }
      }
    }
    this.checkValidStep(this.props);
  }

  componentDidUpdate(prevProps, prevState) {
    const { loanCreationAttempt, settings } = this.props;

    if (loanCreationAttempt) {
      const months = parseInt(loanCreationAttempt.termMonths, 10)
      const amount = parseFloat(loanCreationAttempt.amount)
      const payment = parseFloat(loanCreationAttempt.payment)
      const interest = parseFloat(loanCreationAttempt.interest)

      let newCalculator = {
        amount: amount,
        goal: "WHATEVER",
        interest: interest,
        months: months,
        payment: payment,
        paymentTotal: payment * months,
        provisionFee: parseFloat(loanCreationAttempt.ProvisionFee),
        insurance: loanCreationAttempt.insurance,
        insuranceAmount: getInsurancePrice(loanCreationAttempt.insurance, amount, settings),
      }

      // Only resync the calculator from loanCreationAttempt when the attempt (or
      // settings) actually changed, or on first load. Otherwise a local state
      // update from selecting an insurance package (recalculateInsurance) would
      // trigger this block and clobber the freshly computed insuranceAmount back
      // to the stale loanCreationAttempt.insurance (which is only saved on submit) —
      // causing the price to reset to 0 when switching between packages.
      const attemptChanged = prevProps.loanCreationAttempt !== loanCreationAttempt;
      const settingsChanged = prevProps.settings !== settings;
      if (
        (attemptChanged || settingsChanged || !prevState.calculator) &&
        JSON.stringify(prevState.calculator) !== JSON.stringify(newCalculator)
      ) {
        this.setState({
          calculator: newCalculator,
        })
      }

      const profileData = loanCreationAttempt.profileData
      const existingAccountData = this.state.accountData || {};
      let newAccountData = {
        address: (profileData && profileData.address) ? profileData.address : {},
        income: (profileData && profileData.income) ? profileData.income : {},
        costs: (profileData && profileData.costs) ? profileData.costs : {},
        loan: (profileData && profileData.loan) ? profileData.loan : {},
        nameFirst: loanCreationAttempt.firstName,
        nameLast: loanCreationAttempt.lastName,
        email: loanCreationAttempt.email,
        phone: profileData ? profileData.phone : null,
        iban: profileData ? profileData.iban : null,
        gender: profileData ? profileData.gender : null,
        personalNumber: profileData ? profileData.personalNumber : null,
        idCardNumber: profileData ? profileData.idCardNumber : null,
        maritalStatus: profileData ? profileData.maritalStatus : null,
        kids: profileData ? profileData.kids : null,
        socialStatus: profileData ? profileData.socialStatus : null,
        employer: profileData ? profileData.employer : null,
        incomeFrom: profileData ? profileData.incomeFrom : null,
        sector: profileData ? profileData.sector : null,
        insuranceTaxDebt: profileData ? profileData.insuranceTaxDebt : null,
        obligations: profileData && profileData.obligations ? profileData.obligations : [],
        education: profileData ? profileData.education : null,
        terms: true,
        declarationOfCorrectInformation: true,
        birthLastName: profileData ? loanCreationAttempt.birthLastName : null,
        password: existingAccountData.password,
        repeatPassword: existingAccountData.repeatPassword,
        cookieId: existingAccountData.cookieId || loanCreationAttempt.cookieId || Cookies.get('id'),
      }

      if (JSON.stringify(prevState.accountData) !== JSON.stringify(newAccountData)) {
        this.setState({
          accountData: newAccountData,
        })
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    this.checkValidStep(nextProps);
  }

  checkValidStep(props) {
    const { step, goToStep, calculator } = props;

    if (!this.isStepValid(step)) {
      goToStep(onboardingSteps[0], calculator);
    }
  }

  isStepValid(step) {
    return onboardingSteps.includes(step);
  }

  mergeAndSaveAccountData(formData, cb) {
    this.setState(
      (prevState, props) => {
        const { obligations, ...formDataWithoutObligations } = formData;
        const { obligations: previousObligations, ...accountDataWithoutObligations } = prevState.accountData;
        return ({
          accountData: {
            ...accountDataWithoutObligations,
            ...formDataWithoutObligations,
            loan: {
              goal: prevState.calculator.goal,
              amount: prevState.calculator.amount,
              interest: prevState.calculator.interest,
              months: prevState.calculator.months,
              provisionFee: prevState.calculator.provisionFee,
              insurance: formData.insurance,
              insuranceAmount: prevState.calculator.insuranceAmount,
              obligations: formData.obligations || previousObligations || [],
              insuranceInfo: {
                packageType: formData.insurance,
                insuranceAmount: prevState.calculator.insuranceAmount,
                interestDiscount: 0,
                ageRestriction: formData.insurance === 'C' ? 70 : 62,
                youngerThanLimit: formData.youngerThanLimit,
                pension: formData.pension,
                invalidity: formData.invalidity,
                unableToWork: formData.unableToWork,
                notes: formData.insuranceNotes,
                inRelationshipWithInsCompany: formData.inRelationshipWithInsCompany,
                isPoliticalPerson: formData.isPoliticalPerson,
                isSanctioned: formData.isSanctioned,
                isFinalBenefitor: formData.isFinalBenefitor,
                finalBenefitor: formData.finalBenefitor,
              },
            },
          },
        })
      },
      cb
    );
  }

  saveAndGoToStep = (stepId, formData) => {
    const { goToStep } = this.props;
    const { calculator } = this.state

    this.mergeAndSaveAccountData(formData, () => goToStep(stepId, calculator));
  };

  submit = formData => {
    const { actions } = this.props;
    const { calculator } = this.state;

    this.mergeAndSaveAccountData(formData, () => {
      const accountData = {
        ...this.state.accountData,
        cookieId: this.state.accountData.cookieId || Cookies.get('id'),
        utm_source: localStorage.getItem('utm_source'),
        utm_medium: localStorage.getItem('utm_medium'),
        utm_campaign: localStorage.getItem('utm_campaign'),
      };
      actions.signUp({
        type: 'debtor',
        accountData,
        paymentTotal: calculator.paymentTotal,
      });
    });
  };

  updateLoanAttemptWithInsurance({cookieId, form, step, params: extraParams}) {
    if (!this.state.calculator) {
      return;
    }

    const { months, amount } = this.state.calculator;
    const { settings, interestRange }  = this.props;

    try {
      const params = { ...getLoanCreationAttemptParams(form, months, amount, settings, interestRange), ...extraParams }
      this.props.actions.updateLoanCreationAttemptAction({cookieId, form, step, params})
    } catch (e) {
      return;
    }
  }

  // Recompute the calculator's insurance amount and monthly payment when the
  // debtor selects/clears an insurance package on the insurance step. Keeping
  // calculator as the single source of truth fixes both the displayed price and
  // the value persisted on submit (mergeAndSaveAccountData reads it from here).
  recalculateInsurance = (insuranceValue) => {
    this.setState((prevState) => {
      if (!prevState.calculator) {
        return null;
      }
      const { amount, months } = prevState.calculator;
      const { settings, interestRange } = this.props;

      const insuranceAmount = getInsurancePrice(insuranceValue, amount, settings);
      let interest = getInterestValue(months, interestRange);
      let payment = prevState.calculator.payment;
      if (interest !== null) {
        const discount = getInterestDiscount(insuranceValue, settings);
        if (discount) {
          interest = interest - discount;
        }
        payment = getMonthlyPayment(amount, months, interest) + insuranceAmount;
      }

      return {
        calculator: {
          ...prevState.calculator,
          insurance: insuranceValue,
          insuranceAmount,
          payment,
        },
      };
    });
  };

  renderStepForm() {
    const { step, isLoading } = this.props;
    const { accountData, calculator } = this.state;
    const { loanCreationAttempt } = this.props;

    switch (step) {
      case onboardingSteps[0]:
        return (
          <StepForm1
            saveAndGoToStep={this.saveAndGoToStep}
            accountData={accountData}
            updateLoanCreationAttempt={this.props.actions.updateLoanCreationAttemptAction}
          />
        );
      case onboardingSteps[1]:
        return (
          <StepForm2
            saveAndGoToStep={this.saveAndGoToStep}
            accountData={accountData}
            updateLoanCreationAttempt={this.props.actions.updateLoanCreationAttemptAction}
          />
        );
      case onboardingSteps[2]:
        return (
          <StepForm3
            saveAndGoToStep={this.saveAndGoToStep}
            accountData={accountData}
            isLoading={isLoading}
            updateLoanCreationAttempt={payload => this.updateLoanAttemptWithInsurance(payload)}
          />
        );
      case onboardingSteps[3]:
        return (
          <StepInsurance
            accountData={accountData}
            submit={this.submit}
            isLoading={isLoading}
            calculator={calculator}
            insuranceInfo={loanCreationAttempt ? loanCreationAttempt.insuranceInfo : null}
            onInsuranceChange={this.recalculateInsurance}
            goBack={() => this.props.goToStep(onboardingSteps[2], calculator)}
          />
        );
      default:
    }
  }

  render() {
    const { step } = this.props;
    const { calculator } = this.state

    if (!this.isStepValid(step)) {
      return <div />;
    }

    if (calculator == null) {
      return <Spin spinning={true} />;
    }

    const stepIdx = onboardingSteps.findIndex(sId => sId === step);
    return (
      <StepLayout>
        {{
          Progress: <StepProgress current={stepIdx} />,
          Form: this.renderStepForm(),
          SideBar: <StepSideBar calculator={calculator} />,
        }}
      </StepLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/onboarding/containers/OnboardingDebtorContainer.js